

export const atomKeys = {
    authState: `authState`,
    userState: `userState`,
    castState: `castState`,
    storyState: `storyState`,
};